import axios from 'axios'
import request from 'client/utils/request'
import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { BaseEntityNewInterface } from 'src/shared/schemas/base-entity.schema'
import { EntityIdType } from 'src/shared/schemas/entity-id.schema'

export const fetchBlocks = () => request.get('/blocks')

export const createMasterBlock = (
  content: BaseEntityNewInterface[],
  desktopPreview: string,
  title: string,
) =>
  request.post(`/masters/blocks`, {
    block: {
      content: JSON.stringify(content),
      title,
      desktopPreview,
    },
  })

export const createUserBlock = (
  content: BaseEntityNewInterface[],
  desktopPreview: string,
  title: string,
) =>
  request.post('/users/blocks', {
    block: {
      content: JSON.stringify(content),
      title,
      desktopPreview,
    },
  })

export const createCommonBlock = (
  locale: PageLocaleEnum,
  content: BaseEntityNewInterface[],
  desktopPreview: string,
  mobilePreview: string,
  title: string,
  category: string,
) => {
  return request.post('/commons/blocks', {
    block: {
      locale,
      content: JSON.stringify(content),
      title,
      category,
      desktopPreview,
      mobilePreview,
    },
  })
}

export const deleteUserBlock = (id: string) =>
  request.delete(`/users/${id}/block`)

export const deleteCommonBlock = (id: string) =>
  request.delete(`/commons/${id}/block`)

export const deleteMasterBlock = (id: string) =>
  request.delete(`/masters/${id}/block`)

export const screenshotCreate = (
  entities: BaseEntityNewInterface[],
  rootEntityId: EntityIdType,
  files: File[],
  locale: PageLocaleEnum,
) =>
  axios.post(
    `${process.env.SYSTEME_IO_HOST}/api/dashboard/page-editor/block/screenshot/create`,
    {
      entities,
      rootEntityId,
      files,
      locale,
    },
  )
